module.exports = __webpack_public_path__ + "static/part-3-2f380e729fd2c315bd8739b2193640da.svg";